import ColumnHeader from "@/components/data-table/ColumnHeader";
import DataTable from "@/components/data-table/DataTable";
import { DateConverter, formatAmount } from "@/constants";
import { UserContext } from "@/context/User/UserContext";
import { getHrPartnerJobJustifications } from "@/services/hiring-justification-functions";
import { JobJustification } from "@/types/hiring-justification.types";
import { ColumnDef } from "@tanstack/react-table";
import { useContext } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

const HRPartnerJobApprovals = () => {
	const user = useContext(UserContext);
	const hrJobs = useQuery({
		queryKey: ["jobs", "hr-partner"],
		queryFn: () => getHrPartnerJobJustifications(user?.accessToken!),
		onSuccess: (data) => {
			console.log("Finance Job Justifications:", data);
		},
	});

	const navigate = useNavigate();

	const handleRowClick = (id: number) => {
		navigate(`/hr-partner-job-approval/${id}`);
	};

	return (
		<>
			<div className="flex flex-col sm:flex-row justify-between pb-4 sm:pb-0">
				<div>
					<h1 className="text-4xl font-bold mb-2">HR Partner Approvals</h1>
					<h3 className="text-zinc-600 font-light mb-4">
						Here are a list of job justifications that wait your approval
					</h3>
				</div>
			</div>
			{hrJobs.data ? (
				<DataTable
					columns={Columns}
					data={hrJobs.data}
					rowId="jobid"
					searchColumn="job"
					rowClick={handleRowClick}
				/>
			) : null}
			{hrJobs.isLoading ? (
				<div className="flex justify-center">
					<span className="loader" />
				</div>
			) : hrJobs.isError ? (
				<div className="align-centre">
					<h5 className="text-center">Error showing claims.</h5>
				</div>
			) : (
				hrJobs.data &&
				hrJobs.data.length === 0 && (
					<div className="align-centre">
						<h5 className="text-center">No claims found</h5>
					</div>
				)
			)}
		</>
	);
};

export default HRPartnerJobApprovals;

const Columns: ColumnDef<JobJustification>[] = [
	{
		accessorKey: "jobid",
		enableHiding: false,
		header: ({ column }) => <ColumnHeader column={column} title="Job ID" />,
		// size: 10,
		maxSize: 200,
	},
	{
		accessorKey: "job",
		header: ({ column }) => <ColumnHeader column={column} title="Job Title" />,
	},
	{
		accessorKey: "budgeted_amount",
		header: ({ column }) => (
			<ColumnHeader column={column} title="Budgeted Amount" />
		),
		cell: ({ row }) => {
			return (
				<div className="font-medium">
					{formatAmount(row.getValue("budgeted_amount") as number, "KSH")}
				</div>
			);
		},
	},
	{
		accessorKey: "departmentname",
		header: ({ column }) => <ColumnHeader column={column} title="Department" />,
	},
	{
		accessorKey: "raisedon",
		header: ({ column }) => <ColumnHeader column={column} title="Raised On" />,
		cell: ({ row }) => {
			const date = new Date(row.getValue("raisedon"));
			return DateConverter(date);
		},
	},
];
